angular.module('impactx.orderconfirmation').controller('OrderConfirmationBuyerCtrl', [
    '$scope',
    'dataGen',
    '$controller',
    '$routeParams',
    DeliveryConfirmationBuyerCtrl]);

function DeliveryConfirmationBuyerCtrl($scope, dataGen, $controller, $routeParams) {
    var self = this;
    var parent = $controller('OrderConfirmationCtrl', {$scope: $scope});
    angular.extend(this, parent);
    var pohId = $routeParams.id;
    dataGen.getData($scope, {id: pohId}, "/orderconfirmation/viewbuyer").then(function () {
        parent.defineButtons();
    });
}